var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSoSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SO/Search"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1000009313"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.2225 17.4469C14.6596 17.4469 17.4459 14.6606 17.4459 11.2235C17.4459 7.78634 14.6596 5 11.2225 5C7.78536 5 4.99902 7.78634 4.99902 11.2235C4.99902 14.6606 7.78536 17.4469 11.2225 17.4469Z",
    stroke: "#383434",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M19.0022 19.0012L15.6182 15.6172",
    stroke: "#383434",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoSearch);
export default __webpack_public_path__ + "static/media/so-search.b46f823d12c77e00f245061c0cab3957.svg";
export { ForwardRef as ReactComponent };